module.exports = __webpack_public_path__ + "static/media/logoCenter.0545162f.png";